import type { ReactNode } from 'react';

/**
 * The ASL Go top chrome bar (dark in both themes; yellow is reserved for CTAs).
 * Shared by the main app and the /admin shell so both carry the same branding.
 * The logo links out; `right` holds the page-specific controls.
 */
export function TopBar({ right }: { right?: ReactNode }) {
  return (
    <header className="sticky top-0 z-30 bg-canvas-darker text-ink-100 border-b border-white/[0.06]">
      <div className="w-full max-w-[1280px] mx-auto px-4 sm:px-8 py-3.5 flex items-center gap-2 md:gap-4">
        <a href="https://aslgo.com" className="flex items-center gap-3 group shrink-0">
          <img src="/asl-go-logo.avif" alt="ASL Go" className="h-7 w-auto max-w-none select-none shrink-0 invert" />
        </a>
        <div className="flex-1" />
        {right}
      </div>
    </header>
  );
}
